import { OrganizationsModule } from './../organizations/index';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { DialogModule } from '../dialog';
import { SelectDialogComponent } from './select-dialog.component';
import { WorkspacesModule } from '../workspaces';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    DialogModule,
    OrganizationsModule,
    WorkspacesModule,
  ],
  exports: [
    SelectDialogComponent,
  ],
  declarations: [
    SelectDialogComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectModule { }

